import { BaseApiClient } from './base-client';
import { 
  ServiceStatusResponse, 
  ServiceAction, 
  ServiceLog, 
  ServiceConfig,
  ServiceInfo,
  ServiceOverview,
  ServiceUsageStats
} from '../../types/service';
import { Order } from '../../types/order';

export class ServicesApiClient extends BaseApiClient {
  async getServicesOverview(): Promise<ServiceOverview> {
    return this.get<ServiceOverview>('/api/v1/services/overview');
  }

  async getAllServicesStatus(): Promise<Record<string, ServiceStatusResponse>> {
    return this.get<Record<string, ServiceStatusResponse>>('/api/v1/services/status');
  }

  async getServiceStatus(serviceId: number): Promise<ServiceStatusResponse> {
    return this.get<ServiceStatusResponse>(`/api/v1/services/${serviceId}/status`);
  }

  async startService(serviceId: number): Promise<ServiceAction> {
    return this.post<ServiceAction>(`/api/v1/services/${serviceId}/start`);
  }

  async stopService(serviceId: number): Promise<ServiceAction> {
    return this.post<ServiceAction>(`/api/v1/services/${serviceId}/stop`);
  }

  async restartService(serviceId: number): Promise<ServiceAction> {
    return this.post<ServiceAction>(`/api/v1/services/${serviceId}/restart`);
  }

  async getServiceLogs(serviceId: number, lines: number = 100): Promise<ServiceLog[]> {
    return this.get<ServiceLog[]>(`/api/v1/services/${serviceId}/logs`, {
      params: { lines }
    });
  }

  async executeAction(
    serviceId: number,
    action: string,
    params: Record<string, any> = {}
  ): Promise<ServiceAction> {
    return this.post<ServiceAction>(
      `/api/v1/services/${serviceId}/action`,
      {
        action,
        params
      }
    );
  }

  async getUsageStats(serviceId: number): Promise<ServiceUsageStats> {
    return this.get<ServiceUsageStats>(`/api/v1/services/${serviceId}/stats`);
  }

  async getConfig(serviceId: number): Promise<ServiceConfig> {
    return this.get<ServiceConfig>(`/api/v1/services/${serviceId}/config`);
  }

  async updateConfig(
    serviceId: number,
    config: Partial<ServiceConfig>
  ): Promise<ServiceAction> {
    return this.put<ServiceAction>(
      `/api/v1/services/${serviceId}/config`,
      config
    );
  }

  async retryPayment(serviceId: number): Promise<Order> {
    return this.post<Order>(`/api/v1/services/${serviceId}/retry-payment`);
  }
}
